import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {FileShareInfo, UploadedFileType} from "../models/file-share.models";
@Injectable({
    providedIn: 'root',
})
export class FileShareService {
    #apiUrl = `${environment.apiUrl}/file-share`;
    #http = inject(HttpClient);
    #typeList = '/type-list';
    #upload = '/upload';
    #list = '/list';
    #download = '/download';
    #maxNumFiles = '/max-num-files';

    getTypeList() {
        return this.#http.get<UploadedFileType[]>(`${this.#apiUrl}${this.#typeList}`);
    }

    getMaxNumFiles() {
        return this.#http.get<number | null | undefined>(`${this.#apiUrl}${this.#maxNumFiles}`);
    }

    getFileList() {
        return this.#http.get<FileShareInfo[]>(`${this.#apiUrl}${this.#list}`);
    }

    download(fileId: string) {
        return this.#http.get(`${this.#apiUrl}${this.#download}/${fileId}`, {
            responseType: "arraybuffer"
        });
    }

    upload(
        type: string,
        file: File
    ) {
        const formData = new FormData();
        formData.append('file', file);
        return this.#http.post(`${this.#apiUrl}${this.#upload}?type=${type}`, formData);
    }
}
